export default __webpack_public_path__ + "static/media/currency_monochromatic.785e403f.png";